import React from 'react';
import * as LucideIcons from 'lucide-react';

type IconName = keyof typeof LucideIcons;

interface IconProps {
  name: IconName;
  size?: number | string;
  color?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = '1.5rem', ...rest }) => {
  const IconComponent = LucideIcons[name] as React.ComponentType<Pick<IconProps, 'color' | 'size'>>;

  if (!IconComponent) throw new Error(`Lucide icon "${name}" not found`);

  return <IconComponent size={size} {...rest} />;
};

export { Icon };
export type { IconName };
